
import { defineComponent, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import moment from 'moment'
import { maskStockName, isMaskEnabled } from './tableColumns'

export default defineComponent({
  name: 'AiInterpModal',
  setup(props, { expose }) {
    const route = useRoute()
    const visible = ref(false)
    const stockName = ref('')
    const reason = ref('')
    const updateTime = ref(0)

    const shouldMask = computed(() => isMaskEnabled(route.query.mcnMode as string))

    const displayName = computed(() => {
      return shouldMask.value ? maskStockName(stockName.value) : stockName.value
    })

    const displayReason = computed(() => {
      if (!shouldMask.value || !stockName.value || !reason.value) {
        return reason.value
      }
      const maskedName = maskStockName(stockName.value)
      return reason.value.split(stockName.value).join(maskedName)
    })

    const open = (record: any) => {
      stockName.value = record.name || ''
      reason.value = record.reason || ''
      updateTime.value = record.aiInterpUpdate || 0
      visible.value = true
    }

    const formatTime = (time: number) => {
      if (!time) return '--'
      return moment(time).format('YYYY-MM-DD HH:mm')
    }

    const getContainer = () => {
      return document.body
    }

    expose({
      open
    })

    return {
      visible,
      displayName,
      reason,
      displayReason,
      updateTime,
      formatTime,
      getContainer
    }
  }
})
